import React from 'react';

function NotFound (){
	return <h1 style={{marginTop:74.922, textAlign:"center"}}>404 - Sorry this page is not found</h1>
}

export default NotFound;